import api from './api';

// Devir (açılış) izin bakiyesi — leaveImportService.js ile aynı desen
// (blob indirme + multipart yükleme + iki adımlı doğrula/kaydet).
export const getOpeningBalanceTemplate = () =>
  api.get('/v1/leave-opening-balance/template', { responseType: 'blob' });

export const validateOpeningBalance = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/v1/leave-opening-balance/validate', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// DİKKAT: execute, istemciden gelen `rows`'u VERİ olarak alır, karar olarak
// değil — sunucu isValid/userId alanlarını yok sayıp doğrulamayı sıfırdan
// koşar. Sonuç execute'un DÖNDÜĞÜ satırlardan okunmalıdır.
export const executeOpeningBalance = (rows) =>
  api.post('/v1/leave-opening-balance/execute', { rows });

export const getOpeningBalances = (params = {}) =>
  api.get('/v1/leave-opening-balance', { params });

export const upsertOpeningBalance = (payload) =>
  api.put('/v1/leave-opening-balance', payload);

export const deleteOpeningBalance = (id) =>
  api.delete(`/v1/leave-opening-balance/${id}`);
